module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_3009.cc2188f8.png";